module.exports = __webpack_public_path__ + "static/media/Light grey 11.92d165c0.jpg";